module.exports = __webpack_public_path__ + "static/car1-4233cea77c174102fdc136dfd0505435.jpg";